'use client';

import { useVisible } from '@/hooks';
import type { BlogArticleDocument } from '../../../prismicio-types';
import { ArticleCard } from './ArticleCard/ArticleCard';

import styles from './recomendedArticles.module.scss';
import { BaseURL } from '@/types/articlesList';

interface RecomendedArticlesProps {
  articles: BlogArticleDocument<string>[];
  baseUrl: BaseURL;
}

export const ArticlesList = ({
  articles,
  baseUrl,
}: RecomendedArticlesProps) => {
  const [isVisible, id] = useVisible();
  return (
    <ul className={styles.articles_list} id={id}>
      {articles.map((article) => (
        <li
          key={article.uid}
          className={`${styles.card} ${isVisible ? styles.isVisible : ''}`}
        >
          <ArticleCard article={article} baseUrl={baseUrl} />
        </li>
      ))}
    </ul>
  );
};
